import { IAdFoxBannerOnLoadData } from '@cian/adfox-component';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { AdfoxBanner } from '../../../components/AdfoxBanner';
import { selectIsAgent } from '../../../selectors';
import { useAdfoxBannerActions } from '../hooks/useAdfoxBannerActions';
import { useAdfoxPuids } from '../hooks/useAdfoxPuids';

const ADFOX_PARAMETERS = {
  p1: 'cwhux',
  p2: 'hxqi',
};

export function AsideMortgageBannerContainer() {
  const isAgent = useSelector(selectIsAgent);
  const adfoxPuids = useAdfoxPuids();
  const adfoxParameters = React.useMemo(
    () => ({
      ...adfoxPuids,
      ...ADFOX_PARAMETERS,
    }),
    [adfoxPuids],
  );
  const { onClick, onLoad } = useAdfoxBannerActions();

  /* istanbul ignore next */
  const handleLoad = React.useCallback(
    ({ bundleParams: { bannerId } }: IAdFoxBannerOnLoadData) => {
      onLoad(bannerId);
    },
    [onLoad],
  );

  return (
    <AdfoxBanner
      disableYan={isAgent}
      hideable={false}
      minHeight="100px"
      minWidth="468px"
      params={adfoxParameters}
      onLoad={handleLoad}
      onClick={onClick}
    />
  );
}
